import type { FaireProductEntity } from "../../entity_types/product";

export const p_zxuhk4ntwf: FaireProductEntity = {
  token: "p_zxuhk4ntwf",
  type: "product",
  name: "Owner Of The World's Cutest Cat Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/482fd3cf6db1388d1ad41fe179c61b94a88d8b545dfa56107df2b07d8230e10b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1eee56ccc101fb50d558453c069660d064155223e19cabfcfcf555f3b50ba04.jpeg",
    "https://cdn.faire.com/fastly/f94b2b58895cc6d3bd4bb5aa33bd738789a49a23a2571dfb37dab7e0550f8f44.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/f1750e11a5d576877e50b57fa820b357dfc413120d609f1368cbf0f2aab9620a.jpeg",
    "https://cdn.faire.com/fastly/30901c4b39331cfd7675b474f1d8346d484d15e4635c87f1a3a1921961a0eab4.jpeg",
    "https://cdn.faire.com/fastly/9c563d08280b3c734fc38f8cd05bbfaf8cc44ece2ff80219727e24bf1a86de93.jpeg"
  ],
  priceDollars: 6.75,
  description: "Your cat already knows it’s the world’s cutest (you can tell by how it’s never sorry). Now you can channel that ‘house cat confidence’ in these sleek babies. Soft and cushioned socks for the perfect saunter 😏\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:21.982Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
